import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'cubcm',   label: 'Cubic cm' },
  { key: 'cubmet',  label: 'Cubic m' },
  { key: 'cubinch', label: 'Cubic inch' },
  { key: 'cubfeet', label: 'Cubic feet' },
  { key: 'lit',     label: 'Litres' },
  { key: 'imgall',  label: 'Imperial gal' },
  { key: 'usgall',  label: 'US gal' },
  { key: 'acefeet', label: 'Acre feet' },
  { key: 'tmc',     label: 'TMC' },
];

// Base: cubic cm
const factors = {
  cubcm:   1,
  cubmet:  1 / 1000000,
  cubinch: 1 / 16.387,
  cubfeet: 1 / 28316.847,
  lit:     1 / 1000,
  imgall:  1 / 4546.09,
  usgall:  1 / 3785.412,
  acefeet: 1 / 1233000000,
  tmc:     1 / 28316846592000,
};

export const ConvVolume = () => (
  <UnitConverter
    title="Volume"
    units={units}
    factors={factors}
    explanationTitle="Units of volume"
    explanation="1 cubic foot = 28.317 litres. The English system's cubic foot is approximately 28.3 times a litre of the metric system."
  />
);
